import $ from "jquery";
import { extractErrorResponse } from "../../utils/utils";

export const FORGOT_PASSWORD = "FORGOT_PASSWORD";

export const FORGOT_PASSWORD_REQUEST = "FORGOT_PASSWORD_REQUEST";
export const FORGOT_PASSWORD_COMPLETE = "FORGOT_PASSWORD_COMPLETE";
export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS";
export const FORGOT_PASSWORD_ERROR = "FORGOT_PASSWORD_ERROR";
export const ON_EMAIL_FIELD_CHANGE = "ON_EMAIL_FIELD_CHANGE";

const initialState = {
    isLoading: false,
    email: "",
    showSuccessView: false,
    errorMessageId: "",
};

export function forgotPassword(state = initialState, action) {
    switch (action.type) {
        case FORGOT_PASSWORD_REQUEST:
            return Object.assign({}, state, {
                isLoading: true,
                errorMessageId: "",
            });
        case FORGOT_PASSWORD_COMPLETE:
            return Object.assign({}, state, {
                isLoading: false,
            });
        case ON_EMAIL_FIELD_CHANGE:
            return Object.assign({}, state, {
                email: action.email,
            });
        case FORGOT_PASSWORD_SUCCESS:
            return Object.assign({}, state, {
                showSuccessView: true,
            });
        case FORGOT_PASSWORD_ERROR:
            return Object.assign({}, state, {
                errorMessageId: action.errorMessageId,
            });
        default:
            return state;
    }
}

export function forgotPasswordRequest(email) {
    return {
        type: FORGOT_PASSWORD_REQUEST,
        email: email,
    };
}

export function forgotPasswordComplete() {
    return {
        type: FORGOT_PASSWORD_COMPLETE,
    };
}

export function onEmailFieldChange(email) {
    return {
        type: ON_EMAIL_FIELD_CHANGE,
        email: email,
    };
}

export function forgotPasswordSuccess() {
    return {
        type: FORGOT_PASSWORD_SUCCESS,
    };
}

export function forgotPasswordError(errorMessageId) {
    return {
        type: FORGOT_PASSWORD_ERROR,
        errorMessageId: errorMessageId,
    };
}

export function submitForgotPassword(email) {
    return function(dispatch) {
        dispatch(forgotPasswordRequest());
        let params = {
            email: email,
        };

        $.ajax({
            beforeSend: function(xhr) {
                xhr.setRequestHeader(csrfHeaderName, csrfToken);
            },
            url: "/forgotPassword",
            type: "POST",
            data: JSON.stringify(params),
            contentType: "application/json",
            success: function() {
                dispatch(forgotPasswordSuccess());
            },
            error: function(response) {
                dispatch(forgotPasswordError(extractErrorResponse(response)));
            },
            complete: function() {
                dispatch(forgotPasswordComplete());
            },
        });
    };
}
